import { Component, inject } from '@angular/core';
import { LdwRouterService } from '../../route/ldw-router.service';
import { MessageService } from '../message.service';

@Component({
    selector: 'ldw-messages-button',
    templateUrl: './messages-button.component.html',
    styleUrls: ['./messages-button.component.css'],
    standalone: false
})
export class MessagesButtonComponent {
  private routerService = inject(LdwRouterService);
  private messagesService = inject(MessageService);

  messageCount$;


  constructor() {
    this.messageCount$ = this.messagesService.observe();
  }

  btnClick(e: any) {
    this.routerService.navigateToMessages();
  }
}
